/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:42:52
 */
const s = {
    ballDistance: 26.6,
    diameter: 8.5,
    numRows: 10,
    yMult: 1.2,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [197.9343578666232, 231.88274513038655, 229.76162762332393, 197.86075408280033, 196.936735774911, 196.82399481235294, 232.77946994708427, 232.23915844972467],
        1: [229.86371963748397, 229.9961046657803, 197.4924123113485, 194.91058377870365, 232.7723409736696, 232.1358364792821, 195.77981775269222, 230.40423395488662],
        2: [231.08092485068286, 196.13547612019235, 196.185422527605, 231.33855849521376, 196.25892291975575, 194.75018770329675, 231.6910397078338, 197.18922298147652],
        3: [196.4852289435784, 231.16961682959743, 196.27404754301728, 231.6924539817461, 198.2627742501536, 197.62841038437878, 198.06393670546777, 195.85369128091315],
        4: [230.0420653482608, 230.978483347594, 195.75933490979824, 233.14975289440594, 231.1985698786118, 229.93748681772584, 195.491868654934, 197.09900252756262],
        5: [197.7497820846084, 195.56463663397147, 196.35713060472176, 229.59664372522897, 198.4042887786216, 197.9572461283379, 232.58432121320834, 232.19604880455674],
        6: [229.56624550732332, 231.11349142828206, 230.91848142275836, 195.77617892639825, 195.48354117419868, 195.44362736180568, 196.59616739948365, 231.92279301457103],
        7: [232.29974261441103, 229.9907309705435, 233.18366814058876, 229.93494455897908, 194.8657648169893, 196.09511744963012, 195.29274916720743, 233.0754301440441],
        8: [231.8410962811036, 196.61210879842415, 232.7303561638378, 195.80598934527868, 198.17805551223216, 229.95902375053126, 231.62117012388583, 197.57049341613308],
        9: [231.06081287314223, 195.79529108227518, 194.56500007926354, 233.10072275143307, 231.56896770073448, 197.2271977823819, 198.08870650661498, 231.8161407096769],
        10: [233.0537337750717, 230.17632909100962, 231.73883994695467, 233.41292979269886, 195.2521007248638, 196.847167440127, 195.83068931176962, 230.4648787535885],
        11: []
    }
};
export {s as default};
